import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { TaskAssignObject } from 'src/app/models/tasks/task/task-assign-object.model';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-tasks-tabs',
  templateUrl: './tasks-tabs.component.html',
  styleUrls: ['./tasks-tabs.component.css']
})
export class TasksTabsComponent implements OnInit {

  @Input() isBillingTask: boolean;
  @Input() taskDetails: TaskDetailsObject;
  @Input() currentAssignTask: TaskAssignObject;

  characteristicsUrl = '/provision/tasks/task/details/characteristics';
  scaiUrl = '/provision/tasks/task/details/scai';
  productUrl = '/provision/tasks/task/details/product';
  commentsUrl = '/provision/tasks/task/details/comments';
  billingUrl = '/provision/tasks/task/details/billing';

  CHARACTERISTICS: string = 'characteristics';
  SCAI: string = 'scai';
  PRODUCT: string = 'product';
  COMMENTS: string = 'comments';
  BILLING: string = 'billing';

  option: string = this.CHARACTERISTICS;

  tasksId: string;
  map: string;

  selectedIndex;

  constructor(
    private _router: Router, private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.tasksId = params.id;
      this.map = params.map;
    });
    this.selectedIndex = 0;
  }

  public goToCharacteristics(): void {
    this.option = this.CHARACTERISTICS;
    this.changeUrlOptions(this.option);
  }

  public goToScai(): void {
    this.option = this.SCAI;
    this.changeUrlOptions(this.option);
  }

  public goToProduct(): void {
    this.option = this.PRODUCT;
    this.changeUrlOptions(this.option);
  }

  public goToComments(): void {
    this.option = this.COMMENTS;
    this.changeUrlOptions(this.option);
  }

  public goToBilling(): void {
    this.option = this.BILLING;
    this.changeUrlOptions(this.option);
  }

  public changeUrlOptions(option: string): void {

    let navigationExtras: NavigationExtras = {
      queryParams: {
        id: this.tasksId,
        map: this.map
      }
    };

    this._router.navigate([`/provision/tasks/detail/` + option.toLocaleLowerCase()], navigationExtras);

  }

}
